import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { useMemo, useRef } from 'react';
import { Layout, TopDivider } from './styles.js';
import { useTheme, useMediaQuery, Box, Typography } from '@mui/material';
import ZigSearch from '../ZigSearch/index.js';
import MultiFiltersButton from './dropdowns/MultiFiltersButton/index.js';
import ZigButton from '../../inputs/ZigButton/index.js';
import FilterDropdown from './dropdowns/FilterDropdown/index.js';
import { useDetectWrapping } from '../../../hooks/useDetectWrapping.js';

var GAP = 1;
var ZigFilters = function (_a) {
    var _b, _c;
    var defaultFilters = _a.defaultFilters, _d = _a.filters, filters = _d === void 0 ? [] : _d, onChange = _a.onChange, search = _a.search, onSearchChange = _a.onSearchChange, label = _a.label, leftComponent = _a.leftComponent, rightComponent = _a.rightComponent, sx = _a.sx, _e = _a.prefixId, prefixId = _e === void 0 ? "filters" : _e;
    var theme = useTheme();
    var md = useMediaQuery(theme.breakpoints.up("md"));
    var lg = useMediaQuery(theme.breakpoints.up("lg"));
    var _f = useMemo(function () {
        return [
            filters.filter(function (filter) { return filter.mobile; }),
            filters.filter(function (filter) { return (filter.mobile === "md" ? md && !lg : filter.primary); }),
            filters.filter(function (filter) { return !filter.mobile && (!filter.primary || !md); }),
        ];
    }, [filters, md, lg]), mobileFilters = _f[0], mainFilters = _f[1], secondaryFilters = _f[2];
    var updateFilter = function (updatedFilter) {
        var updatedFilters = filters.map(function (filter) {
            if (filter.id === updatedFilter.id) {
                return updatedFilter;
            }
            return filter;
        });
        onChange(updatedFilters);
    };
    var resetFilters = function () {
        onChange(defaultFilters);
    };
    var resetFilter = function (id) {
        var updatedFilters = filters.map(function (filter) {
            if (filter.id === id) {
                return defaultFilters.find(function (defaultFilter) { return defaultFilter.id === id; });
            }
            return filter;
        });
        onChange(updatedFilters);
    };
    var resetSecondaryFilters = function () {
        var updatedFilters = filters.map(function (filter) {
            if (secondaryFilters.find(function (secondaryFilter) { return secondaryFilter.id === filter.id; })) {
                return defaultFilters.find(function (defaultFilter) { return defaultFilter.id === filter.id; });
            }
            return filter;
        });
        onChange(updatedFilters);
    };
    var inlineMultiFilters = md && secondaryFilters.length > 0;
    var containerRef = useRef(null);
    var rightRef = useRef(null);
    var isWrapped = useDetectWrapping(containerRef) && md;
    return (React__default.createElement(Box, { display: "flex", flex: 1, alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: GAP, mb: { xs: 2, sm: 3.5 }, mx: { sm: 1, md: 0 }, sx: sx, ref: containerRef },
        React__default.createElement(Box, { display: "flex", flex: 1, justifyContent: "flex-start", flexBasis: !md && mobileFilters.length ? "100%" : 0, borderRight: isWrapped
                ? "".concat(((_c = (_b = rightRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) !== null && _c !== void 0 ? _c : 0) + GAP * 8 * 2, "px solid transparent")
                : "none" }, leftComponent),
        !md && (React__default.createElement(Box, { display: "flex", flex: 1, justifyContent: "flex-start" }, mobileFilters.map(function (filter, i) { return (React__default.createElement(FilterDropdown, { resetFilter: function () { return resetFilter(filter.id); }, filter: filter, key: filter.id, onChange: updateFilter, separator: i < mobileFilters.length - 1, mobile: !md, prefixId: prefixId })); }))),
        React__default.createElement(Box, { justifyContent: isWrapped
                ? "flex-start"
                : {
                    sm: "flex-start",
                    md: "center",
                }, display: "flex", gap: 1, alignItems: "center", flex: 1, flexGrow: !md ? 0 : 5 },
            React__default.createElement(Box, { display: "flex", gap: { xs: 1, sm: 2 }, alignItems: "center", justifyContent: "center" },
                React__default.createElement(Layout, { label: label, mobile: !md },
                    label && (React__default.createElement(TopDivider, null,
                        React__default.createElement(Typography, { variant: "h4", fontWeight: 400 }, label))),
                    React__default.createElement(Box, __assign({ display: "flex", alignItems: "center" }, (!md && { gap: 1, flexWrap: "wrap" })),
                        md &&
                            mainFilters.map(function (filter, i) { return (React__default.createElement(FilterDropdown, { resetFilter: function () { return resetFilter(filter.id); }, filter: filter, key: filter.id, onChange: updateFilter, separator: md && (inlineMultiFilters || i < mainFilters.length - 1), mobile: !md, prefixId: prefixId })); }),
                        inlineMultiFilters && (React__default.createElement(MultiFiltersButton, { resetFilters: resetSecondaryFilters, defaultFilters: defaultFilters, filters: secondaryFilters, onChange: updateFilter, mobile: false, prefixId: prefixId })))),
                md && (React__default.createElement(ZigButton, { variant: "text", onClick: resetFilters, id: "".concat(prefixId, "__reset-all") }, "Reset")))),
        React__default.createElement(Box, { flex: !lg ? 0 : 1, display: "flex", justifyContent: "flex-end", position: "relative", alignItems: "center", gap: 1.5, ref: rightRef },
            React__default.createElement(React__default.Fragment, null,
                rightComponent,
                search !== undefined && onSearchChange && md && (React__default.createElement(Box, { mr: "42px" },
                    React__default.createElement(ZigSearch, { value: search, onChange: onSearchChange, sx: {
                            position: "absolute",
                            right: 0,
                            top: 0,
                            bottom: 0,
                        }, id: "".concat(prefixId, "__search") })))),
            !md && secondaryFilters.length > 0 && (React__default.createElement(MultiFiltersButton, { resetFilters: resetSecondaryFilters, defaultFilters: defaultFilters, filters: secondaryFilters, onChange: updateFilter, mobile: true, prefixId: prefixId })))));
};

export { ZigFilters as default };
